import { deepValue } from '@corratech/pylot-utils'
import { formatPrice } from '@corratech/pylot-seo'
import { CartItemInterface } from '@pylot-data/pylotschema'

export const getCartItemPrice = (
    item: CartItemInterface,
    pricePath = ['prices', 'row_total_including_tax', 'value']
): string => {
    const rowTotal: number | null = deepValue(item, pricePath, null)
    const quantity: number = deepValue(item, ['quantity'], 1)
    const price =
        rowTotal !== null
            ? rowTotal / quantity
            : Number(deepValue(item, ['prices', 'price', 'value'], 0))
    return formatPrice(price)
}
